import React, { useEffect, useState } from 'react';

// custom compoentns
import { LegendItem, SimpleTable, CustomSubtitle, CustomMetric } from '_atoms';
import FlightTableCard from './flight-table-card';

// tremor
import { Card, Title, Metric, Flex } from '@tremor/react';

// styling
import { Colors, Spacing } from '_styles';

// bootstrap
import { Placeholder, Card as BootstrapCard, Dropdown } from 'react-bootstrap';

const LiveFlightTimesCard = (props) => {

    return (
        <div style={{  minHeight:'100%', height: '100%', width: '100%'}}>
            <BootstrapCard style={{ height: '100%', width: '100%' }}>
                <div style={{ padding:Spacing.SCALE_22 }}>

                    <Flex>
                        <CustomSubtitle>Live Flight Times</CustomSubtitle>
                    </Flex>

                        <FlightTableCard
                            headers={['Flight', 'Status', 'Time', 'Passengers', 'Gate']}
                            data={[
                                { flight: 'BA1399', status: 'Take Off', time: '10:44', passengers: 2, gate: 14, type:'outbound' },
                                { flight: 'U29887', status: 'Touchdown', time: '10:44', passengers: 2, gate: 14, type:'inbound' },
                                { flight: 'U29876', status: 'Take Off', time: '10:44', passengers: 2, gate: 14, type:'outbound' },
                                { flight: 'U29878', status: 'Take Off', time: '10:44', passengers: 2, gate: 14, type:'outbound' },
                                { flight: 'U29639', status: 'On Blocks', time: '10:44', passengers: 2, gate: 14, type:'inbound' },
                                { flight: 'SI3370', status: 'Out Blocks', time: '10:44', passengers: 2, gate: 14, type:'outbound' },
                                { flight: 'QS4497', status: 'Out Blocks', time: '10:44', passengers: 2, gate: 14, type:'outbound' },
                                { flight: 'SI3371', status: 'On Blocks', time: '10:44', passengers: 2, gate: 14, type:'inbound' },
                                { flight: 'U29876', status: 'Take Off', time: '10:44', passengers: 2, gate: 14, type:'outbound' },
                                { flight: 'SI3371', status: 'On Blocks', time: '10:44', passengers: 2, gate: 14, type:'inbound' },
                                { flight: 'U29878', status: 'Take Off', time: '10:44', passengers: 2, gate: 14, type:'outbound' },
                                { flight: 'BA1399', status: 'Take Off', time: '10:44', passengers: 2, gate: 14, type:'outbound' },

                            ]}
                            totalNumber={9}
                            backEndPagination={false}
                        />

                </div>
            </BootstrapCard>
        </div>
    );
};

export default LiveFlightTimesCard;
